import React, { useState, useImperativeHandle, useEffect } from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

export const SelectOrdem = React.forwardRef(({ onChange, options, selectedOption: propSelectedOption }, ref) => {
  const [selectedOption, setSelectedOption] = useState(propSelectedOption || options[0]);

  // Update local state when the prop changes
  useEffect(() => {
    if (propSelectedOption) {
      setSelectedOption(propSelectedOption);
      return;
    }
    setSelectedOption(options[0]);
  }, [propSelectedOption, options]);

  const handleSelectionChange = (selected) => {
    setSelectedOption(selected);
    onChange(selected);
  };

  useImperativeHandle(ref, () => ({
    setOption: (option) => {
      setSelectedOption(option);  // Set the selected option directly
      onChange(option);           // Optionally trigger the onChange handler
    },
    resetSelect: () => {
      const defaultOption = { value: '&ordenar_por=data_publicacao%20asc', label: 'Ordem Decrescente' };
      setSelectedOption(defaultOption);  // Reset to the default option
      onChange(defaultOption);           // Optionally trigger the onChange handler
    }
  }));

  return (
    <div className='Select'>
      <Select
        closeMenuOnSelect={true}
        components={animatedComponents}
        value={selectedOption}
        options={options}
        onChange={handleSelectionChange}
        placeholder={<div>Selecione...</div>}
      />
    </div>
  );
});
